module.exports = __webpack_public_path__ + "img/icon.77f99dce.svg";